import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { memo } from 'react';
import StatCard from 'components/molecules/stat-card';

import s from './styles.module.scss';
import { useButtons } from './use-buttons';

import type { FC } from 'react';

const RiskConditionFilter: FC = () => {
  const { buttons, countLoading } = useButtons();

  return (
    <BaseSpinWrapper spinning={countLoading}>
      <div className={s.wrapper}>
        {buttons.map(({ active, bgColor, count, status, label, onClick }) => {
          return (
            <StatCard
              key={label}
              active={active}
              bgColor={bgColor}
              count={count}
              label={label}
              onClick={onClick}
              showCrown={status === 'slaReadings'}
              dataStatus={status}
              titleClassNames={s.title}
              countClassNames={s.count}
              btnClassNames={s.item}
              bgClassNames={s.bg}
            />
          );
        })}
      </div>
    </BaseSpinWrapper>
  );
};
export default memo(RiskConditionFilter);
